import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { FETCH_ADOBE_AUTHN, CLEAR_ADOBE_AUTH } from 'actions/auth';
import { ADOBE_ACCESS_TOKEN } from 'actions/adobeClient';

const INITIAL_STATE = Immutable({
  loading: false,
  accessToken: null,
  authN: null,
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${ADOBE_ACCESS_TOKEN}_LOADING`:
    case `${FETCH_ADOBE_AUTHN}_LOADING`:
      return state.merge({ loading: true, error: null });
    case `${ADOBE_ACCESS_TOKEN}_ERROR`:
    case `${FETCH_ADOBE_AUTHN}_ERROR`:
      return state.merge({ loading: false, error: action.payload });
    case ADOBE_ACCESS_TOKEN: {
      return state.merge({
        loading: false,
        error: null,
        accessToken: action.payload,
      });
    }
    case FETCH_ADOBE_AUTHN: {
      return state.merge({
        loading: false,
        error: null,
        authN: action.payload,
      });
    }
    case CLEAR_ADOBE_AUTH: {
      return state.merge({
        loading: false,
        error: null,
        authN: null,
      });
    }
    default:
      return state;
  }
};
